// Mock data structure - will be replaced with live API data
export interface TokenData {
  name: string;
  symbol: string;
  price: number;
  marketCap: number;
  change24h: number;
  change7d: number;
  volume24h: number;
  roiScore: number;
  roiPotential: number;
  listedOnSwyftx: boolean;
  listedOnCoinspot: boolean;
  entryZone: [number, number];
  stopLoss: number;
  targetA: number;
  targetB: number;
  targetC: number;
  riskLevel: "LOW" | "MEDIUM" | "HIGH";
  teamScore: number;
  timestamp: string;
  sector: string;
  catalysts: string[];
  whyBuy: string;
  technicalReason: string;
  momentumReason: string;
  catalystReason: string;
  scores: {
    momentum: number;
    marketCap: number;
    team: number;
    catalysts: number;
    onChain: number;
    sentiment: number;
  };
}

// Focus on low-cap tokens (under $500M) for maximum ROI potential
export const mockTokens: TokenData[] = [
  // AI SECTOR (Low-Cap Gems)
  {
    name: "Phala Network",
    symbol: "PHA",
    price: 0.187,
    marketCap: 195000000, // $195M - Low cap
    change24h: 15.3,
    change7d: 42.8,
    volume24h: 28000000,
    roiScore: 94,
    roiPotential: 850,
    listedOnSwyftx: true,
    listedOnCoinspot: false,
    entryZone: [0.175, 0.195],
    stopLoss: 0.152,
    targetA: 0.485,
    targetB: 0.920,
    targetC: 1.775,
    riskLevel: "HIGH",
    teamScore: 9,
    sector: "ai",
    timestamp: new Date().toISOString(),
    whyBuy: "Privacy-focused AI computation on Polkadot with explosive upside as AI agents need secure compute",
    technicalReason: "Breaking out of 8-month accumulation zone with 300% volume surge",
    momentumReason: "AI narrative + Polkadot ecosystem gaining massive traction",
    catalystReason: "Major AI agent platform integration announcement due Q1 2025",
    catalysts: [
      "TEE-based AI computation protocol gaining enterprise adoption",
      "Polkadot parachain synergies driving value",
      "Partnership with AI Agent Summit sponsors confirmed"
    ],
    scores: {
      momentum: 95,
      marketCap: 92,
      team: 90,
      catalysts: 93,
      onChain: 88,
      sentiment: 89
    }
  },
  {
    name: "MyNeighborAlice",
    symbol: "ALICE",
    price: 1.34,
    marketCap: 124000000, // $124M - Very low cap
    change24h: 18.7,
    change7d: 38.5,
    volume24h: 42000000,
    roiScore: 91,
    roiPotential: 920,
    listedOnSwyftx: true,
    listedOnCoinspot: true,
    entryZone: [1.25, 1.42],
    stopLoss: 1.08,
    targetA: 3.20,
    targetB: 6.85,
    targetC: 13.70,
    riskLevel: "HIGH",
    teamScore: 8,
    sector: "gaming",
    timestamp: new Date().toISOString(),
    whyBuy: "Gaming metaverse with AI NPCs - perfect timing for 2025 gaming bull run",
    technicalReason: "Golden cross forming on weekly chart, RSI showing strength",
    momentumReason: "GameFi sector rotation beginning, early mover advantage",
    catalystReason: "Mobile game launch + AI NPC update scheduled Q1 2025",
    catalysts: [
      "Mobile version launching with 50K+ pre-registrations",
      "AI-powered NPCs creating viral social media buzz",
      "Partnership with major gaming guild announced"
    ],
    scores: {
      momentum: 92,
      marketCap: 94,
      team: 85,
      catalysts: 90,
      onChain: 87,
      sentiment: 91
    }
  },
  
  // DeFi SECTOR (Low-Cap Yield Gems)
  {
    name: "Radix",
    symbol: "XRD",
    price: 0.0285,
    marketCap: 340000000, // $340M - Low cap
    change24h: 12.4,
    change7d: 35.2,
    volume24h: 18000000,
    roiScore: 89,
    roiPotential: 680,
    listedOnSwyftx: false,
    listedOnCoinspot: false,
    entryZone: [0.0265, 0.0305],
    stopLoss: 0.0232,
    targetA: 0.0685,
    targetB: 0.142,
    targetC: 0.222,
    riskLevel: "MEDIUM",
    teamScore: 9,
    sector: "defi",
    timestamp: new Date().toISOString(),
    whyBuy: "Next-gen DeFi platform solving Ethereum's composability issues - institutional darling",
    technicalReason: "Accumulation phase complete, breaking resistance with volume",
    momentumReason: "DeFi 2.0 narrative + Babylon testnet creating massive buzz",
    catalystReason: "Babylon mainnet launch + major DEX launches incoming",
    catalysts: [
      "Babylon mainnet upgrade (Feb 2025) - game changer",
      "Multiple Tier-1 DEXs building on Radix",
      "Institutional DeFi partnerships being announced"
    ],
    scores: {
      momentum: 88,
      marketCap: 90,
      team: 95,
      catalysts: 92,
      onChain: 85,
      sentiment: 84
    }
  },
  {
    name: "Frax Share",
    symbol: "FXS",
    price: 3.24,
    marketCap: 285000000, // $285M - Low cap
    change24h: 9.8,
    change7d: 28.4,
    volume24h: 32000000,
    roiScore: 87,
    roiPotential: 540,
    listedOnSwyftx: true,
    listedOnCoinspot: false,
    entryZone: [3.05, 3.40],
    stopLoss: 2.75,
    targetA: 6.20,
    targetB: 11.50,
    targetC: 20.75,
    riskLevel: "MEDIUM",
    teamScore: 9,
    sector: "defi",
    timestamp: new Date().toISOString(),
    whyBuy: "Algorithmic stablecoin protocol with RWA expansion - massively undervalued",
    technicalReason: "Bottom formation complete, trending above 200-day MA",
    momentumReason: "Real-world asset tokenization trend accelerating",
    catalystReason: "FraxChain L2 launch + RWA expansion announced",
    catalysts: [
      "FraxChain (Ethereum L2) launching Q1 2025",
      "Real-world asset integration with BlackRock partnership rumors",
      "frxETH gaining massive traction vs competitors"
    ],
    scores: {
      momentum: 85,
      marketCap: 89,
      team: 92,
      catalysts: 88,
      onChain: 86,
      sentiment: 83
    }
  },

  // LAYER 1 (Undervalued Infrastructure)
  {
    name: "Nervos Network",
    symbol: "CKB",
    price: 0.0158,
    marketCap: 700000000, // $700M - Low cap for L1
    change24h: 6.3,
    change7d: 19.7,
    volume24h: 95000000,
    roiScore: 85,
    roiPotential: 420,
    listedOnSwyftx: true,
    listedOnCoinspot: false,
    entryZone: [0.0148, 0.0168],
    stopLoss: 0.0132,
    targetA: 0.0420,
    targetB: 0.0785,
    targetC: 0.0820,
    riskLevel: "MEDIUM",
    teamScore: 8,
    sector: "layer1",
    timestamp: new Date().toISOString(),
    whyBuy: "Bitcoin's best Layer 2 solution - RGB++ protocol is revolutionary",
    technicalReason: "Solid base formation, breaking key resistance levels",
    momentumReason: "Bitcoin Layer 2 narrative just beginning, CKB is the leader",
    catalystReason: "RGB++ adoption accelerating + major exchange listings pending",
    catalysts: [
      "RGB++ protocol gaining serious developer adoption",
      "Bitcoin Layer 2 narrative strengthening across crypto",
      "Binance listing rumors + institutional interest"
    ],
    scores: {
      momentum: 82,
      marketCap: 88,
      team: 85,
      catalysts: 87,
      onChain: 83,
      sentiment: 80
    }
  },
  {
    name: "Conflux Network",
    symbol: "CFX",
    price: 0.185,
    marketCap: 820000000, // $820M - Low cap
    change24h: 9.2,
    change7d: 21.4,
    volume24h: 145000000,
    roiScore: 83,
    roiPotential: 380,
    listedOnSwyftx: false,
    listedOnCoinspot: false,
    entryZone: [0.175, 0.195],
    stopLoss: 0.158,
    targetA: 0.485,
    targetB: 0.885,
    targetC: 0.705,
    riskLevel: "MEDIUM",
    teamScore: 7,
    sector: "layer1",
    timestamp: new Date().toISOString(),
    whyBuy: "China's only compliant blockchain - massive government backing",
    technicalReason: "Consolidation phase ending, preparing for breakout",
    momentumReason: "Chinese crypto regulations easing, institutional flow incoming",
    catalystReason: "Government smart city pilots expanding nationwide",
    catalysts: [
      "China's only compliant public blockchain with gov support",
      "Government-backed smart city pilots expanding to 50+ cities",
      "Integration with major Chinese tech platforms (Xiaomi confirmed)"
    ],
    scores: {
      momentum: 80,
      marketCap: 86,
      team: 78,
      catalysts: 85,
      onChain: 79,
      sentiment: 82
    }
  },

  // LAYER 2 (Scaling Solutions)
  {
    name: "Metis",
    symbol: "METIS",
    price: 42.50,
    marketCap: 420000000, // $420M - Low cap for L2
    change24h: 14.2,
    change7d: 32.8,
    volume24h: 58000000,
    roiScore: 88,
    roiPotential: 580,
    listedOnSwyftx: false,
    listedOnCoinspot: false,
    entryZone: [39.50, 45.00],
    stopLoss: 35.20,
    targetA: 95.00,
    targetB: 185.00,
    targetC: 290.00,
    riskLevel: "MEDIUM",
    teamScore: 8,
    sector: "layer2",
    timestamp: new Date().toISOString(),
    whyBuy: "Ethereum L2 with decentralized sequencer - only one solving the problem",
    technicalReason: "Cup and handle pattern forming, breakout imminent",
    momentumReason: "L2 wars heating up, decentralized sequencer is killer feature",
    catalystReason: "Vitalik endorsement + major protocol migrations incoming",
    catalysts: [
      "Only L2 with decentralized sequencer (huge competitive advantage)",
      "Vitalik Buterin publicly praised Metis approach",
      "Major DeFi protocols migrating to Metis for decentralization"
    ],
    scores: {
      momentum: 87,
      marketCap: 90,
      team: 85,
      catalysts: 89,
      onChain: 86,
      sentiment: 87
    }
  },
  {
    name: "Boba Network",
    symbol: "BOBA",
    price: 0.285,
    marketCap: 158000000, // $158M - Very low cap
    change24h: 22.5,
    change7d: 48.7,
    volume24h: 24000000,
    roiScore: 86,
    roiPotential: 720,
    listedOnSwyftx: false,
    listedOnCoinspot: false,
    entryZone: [0.265, 0.305],
    stopLoss: 0.232,
    targetA: 0.785,
    targetB: 1.520,
    targetC: 2.340,
    riskLevel: "HIGH",
    teamScore: 7,
    sector: "layer2",
    timestamp: new Date().toISOString(),
    whyBuy: "Hybrid compute Layer 2 enabling Web2 integration - sleeping giant",
    technicalReason: "Massive accumulation zone forming, spring loading",
    momentumReason: "Hybrid compute narrative unique in L2 space",
    catalystReason: "Major CEX listings + hybrid compute showcase Q1",
    catalysts: [
      "Hybrid compute enables Web2 API calls on-chain (revolutionary)",
      "Binance listing application in final stages",
      "Gaming partnerships leveraging hybrid compute announced"
    ],
    scores: {
      momentum: 84,
      marketCap: 93,
      team: 80,
      catalysts: 86,
      onChain: 82,
      sentiment: 85
    }
  },

  // GAMING (Explosive Growth Sector)
  {
    name: "Illuvium",
    symbol: "ILV",
    price: 52.40,
    marketCap: 385000000, // $385M - Low cap
    change24h: 11.8,
    change7d: 29.4,
    volume24h: 45000000,
    roiScore: 90,
    roiPotential: 640,
    listedOnSwyftx: true,
    listedOnCoinspot: false,
    entryZone: [48.50, 56.00],
    stopLoss: 43.20,
    targetA: 125.00,
    targetB: 245.00,
    targetC: 390.00,
    riskLevel: "MEDIUM",
    teamScore: 9,
    sector: "gaming",
    timestamp: new Date().toISOString(),
    whyBuy: "AAA gaming quality meets crypto - full suite of games launching 2025",
    technicalReason: "Multi-year base completed, beginning markup phase",
    momentumReason: "Gaming bull cycle starting, ILV is tier-1 play",
    catalystReason: "Overworld + Arena full launches Q1-Q2 2025",
    catalysts: [
      "Illuvium Overworld full launch Q1 2025 (highly anticipated)",
      "Illuvium Arena competitive season starting with $2M prize pool",
      "Mobile versions announced for 2025 (massive audience expansion)"
    ],
    scores: {
      momentum: 89,
      marketCap: 91,
      team: 93,
      catalysts: 92,
      onChain: 87,
      sentiment: 90
    }
  },

  // NFT/METAVERSE
  {
    name: "Wilder World",
    symbol: "WILD",
    price: 0.485,
    marketCap: 198000000, // $198M - Low cap
    change24h: 16.9,
    change7d: 41.2,
    volume24h: 22000000,
    roiScore: 87,
    roiPotential: 780,
    listedOnSwyftx: false,
    listedOnCoinspot: false,
    entryZone: [0.450, 0.520],
    stopLoss: 0.395,
    targetA: 1.420,
    targetB: 2.850,
    targetC: 4.270,
    riskLevel: "HIGH",
    teamScore: 8,
    sector: "nft",
    timestamp: new Date().toISOString(),
    whyBuy: "Photorealistic metaverse built on Unreal Engine 5 - blows away competition",
    technicalReason: "Inverse head and shoulders pattern completing",
    momentumReason: "Metaverse narrative returning with Apple Vision Pro adoption",
    catalystReason: "Wiami (Miami metaverse) public launch + VR support",
    catalysts: [
      "Wiami metaverse city launching (100K+ users already exploring)",
      "Unreal Engine 5 delivering AAA graphics quality",
      "Apple Vision Pro support confirmed for 2025"
    ],
    scores: {
      momentum: 86,
      marketCap: 92,
      team: 88,
      catalysts: 89,
      onChain: 84,
      sentiment: 86
    }
  },

  // PAYMENTS
  {
    name: "Celer Network",
    symbol: "CELR",
    price: 0.0185,
    marketCap: 168000000, // $168M - Very low cap
    change24h: 19.3,
    change7d: 44.8,
    volume24h: 38000000,
    roiScore: 92,
    roiPotential: 850,
    listedOnSwyftx: true,
    listedOnCoinspot: false,
    entryZone: [0.0170, 0.0200],
    stopLoss: 0.0148,
    targetA: 0.0520,
    targetB: 0.0985,
    targetC: 0.1575,
    riskLevel: "HIGH",
    teamScore: 9,
    sector: "payments",
    timestamp: new Date().toISOString(),
    whyBuy: "Cross-chain bridge infrastructure powering the multi-chain future",
    technicalReason: "Bottoming pattern complete, volume surge beginning",
    momentumReason: "Cross-chain activity exploding, CELR is the picks and shovels",
    catalystReason: "Major protocol integrations + Binance research highlight",
    catalysts: [
      "cBridge processing $10B+ in cross-chain volume monthly",
      "80+ blockchains integrated (network effects compounding)",
      "State Guard Network launch making bridges hack-proof"
    ],
    scores: {
      momentum: 91,
      marketCap: 94,
      team: 90,
      catalysts: 93,
      onChain: 89,
      sentiment: 88
    }
  },

  // MEME (High Risk/High Reward)
  {
    name: "Floki Inu",
    symbol: "FLOKI",
    price: 0.000142,
    marketCap: 1350000000, // $1.35B - Larger meme but still room
    change24h: 28.4,
    change7d: 62.8,
    volume24h: 285000000,
    roiScore: 78,
    roiPotential: 320,
    listedOnSwyftx: true,
    listedOnCoinspot: true,
    entryZone: [0.000130, 0.000155],
    stopLoss: 0.000112,
    targetA: 0.000285,
    targetB: 0.000485,
    targetC: 0.000595,
    riskLevel: "HIGH",
    teamScore: 6,
    sector: "meme",
    timestamp: new Date().toISOString(),
    whyBuy: "Meme coin with actual utility - metaverse + DeFi ecosystem",
    technicalReason: "Breaking multi-month resistance, parabolic setup forming",
    momentumReason: "Meme season starting, FLOKI has strongest fundamentals",
    catalystReason: "Valhalla metaverse game launch + major CEX listings",
    catalysts: [
      "Valhalla metaverse game entering open beta Q1 2025",
      "Partnership with major football club announced",
      "Listed on Binance, Coinbase - tier 1 meme status"
    ],
    scores: {
      momentum: 82,
      marketCap: 72,
      team: 68,
      catalysts: 80,
      onChain: 85,
      sentiment: 92
    }
  },

  // PRIVACY
  {
    name: "Secret Network",
    symbol: "SCRT",
    price: 0.485,
    marketCap: 285000000, // $285M - Low cap
    change24h: 13.7,
    change7d: 34.2,
    volume24h: 32000000,
    roiScore: 84,
    roiPotential: 520,
    listedOnSwyftx: false,
    listedOnCoinspot: false,
    entryZone: [0.450, 0.520],
    stopLoss: 0.395,
    targetA: 1.250,
    targetB: 2.400,
    targetC: 3.010,
    riskLevel: "MEDIUM",
    teamScore: 8,
    sector: "privacy",
    timestamp: new Date().toISOString(),
    whyBuy: "Privacy smart contracts enabling confidential DeFi - regulatory tailwind",
    technicalReason: "Long-term downtrend broken, trend reversal confirmed",
    momentumReason: "Privacy narrative strengthening with regulatory clarity",
    catalystReason: "IBC integration + confidential DeFi protocols launching",
    catalysts: [
      "Only blockchain with privacy-preserving smart contracts at scale",
      "IBC integration connecting to entire Cosmos ecosystem",
      "Confidential DeFi applications launching (unique use case)"
    ],
    scores: {
      momentum: 83,
      marketCap: 87,
      team: 85,
      catalysts: 84,
      onChain: 81,
      sentiment: 80
    }
  },

  // STORAGE/INFRASTRUCTURE
  {
    name: "Arweave",
    symbol: "AR",
    price: 18.50,
    marketCap: 1210000000, // $1.21B - Larger but still growth potential
    change24h: 8.4,
    change7d: 22.6,
    volume24h: 95000000,
    roiScore: 81,
    roiPotential: 280,
    listedOnSwyftx: true,
    listedOnCoinspot: false,
    entryZone: [17.20, 19.80],
    stopLoss: 15.50,
    targetA: 35.00,
    targetB: 58.00,
    targetC: 70.00,
    riskLevel: "LOW",
    teamScore: 9,
    sector: "storage",
    timestamp: new Date().toISOString(),
    whyBuy: "Permanent data storage for AI training data - massive institutional demand",
    technicalReason: "Higher lows forming, accumulation by smart money visible",
    momentumReason: "AI data storage narrative accelerating exponentially",
    catalystReason: "Major AI companies adopting + AO computer launch",
    catalysts: [
      "AO hyper-parallel computer launching on Arweave",
      "AI companies using Arweave for permanent training data storage",
      "Solana integration bringing massive transaction volume"
    ],
    scores: {
      momentum: 80,
      marketCap: 78,
      team: 92,
      catalysts: 85,
      onChain: 83,
      sentiment: 79
    }
  },

  // REAL WORLD ASSETS (RWA)
  {
    name: "Centrifuge",
    symbol: "CFG",
    price: 0.385,
    marketCap: 238000000, // $238M - Low cap
    change24h: 10.2,
    change7d: 26.8,
    volume24h: 18000000,
    roiScore: 86,
    roiPotential: 620,
    listedOnSwyftx: false,
    listedOnCoinspot: false,
    entryZone: [0.360, 0.410],
    stopLoss: 0.315,
    targetA: 0.985,
    targetB: 1.850,
    targetC: 2.770,
    riskLevel: "MEDIUM",
    teamScore: 9,
    sector: "rwa",
    timestamp: new Date().toISOString(),
    whyBuy: "Real-world asset tokenization leader - institutional money pouring in",
    technicalReason: "Breaking out of year-long consolidation range",
    momentumReason: "RWA tokenization is THE narrative for 2025 institutional adoption",
    catalystReason: "Major asset manager partnerships + $1B+ assets tokenized",
    catalysts: [
      "$500M+ in real-world assets already tokenized on Centrifuge",
      "Partnership with major asset managers (MakerDAO integration)",
      "BlackRock RWA tokenization trend benefiting entire sector"
    ],
    scores: {
      momentum: 85,
      marketCap: 90,
      team: 88,
      catalysts: 87,
      onChain: 84,
      sentiment: 82
    }
  }
];

// Helper function to get tokens by sector
export const getTokensBySector = (sector: string): TokenData[] => {
  if (sector === "all") return mockTokens;
  return mockTokens.filter(token => token.sector === sector);
};

// Get top N tokens by ROI for a sector
export const getTopROITokens = (sector: string, limit: number = 5): TokenData[] => {
  const sectorTokens = getTokensBySector(sector);
  return sectorTokens
    .sort((a, b) => b.roiPotential - a.roiPotential)
    .slice(0, limit);
};

// Get sector stats
export const getSectorStats = (sector: string) => {
  const tokens = getTokensBySector(sector);
  
  // Handle empty sectors
  if (tokens.length === 0) {
    return {
      count: 0,
      topToken: {
        name: "Coming Soon",
        symbol: "N/A",
        roiPotential: 0
      },
      avgROI: 0
    };
  }
  
  const topToken = tokens.reduce((max, token) => 
    token.roiPotential > max.roiPotential ? token : max
  , tokens[0]);
  
  return {
    count: tokens.length,
    topToken: {
      name: topToken.name,
      symbol: topToken.symbol,
      roiPotential: topToken.roiPotential
    },
    avgROI: tokens.reduce((sum, t) => sum + t.roiPotential, 0) / tokens.length
  };
};

// Sector information
export const sectorInfo: Record<string, { name: string; emoji: string; description: string }> = {
  all: { name: "All Sectors", emoji: "🔥", description: "Top performing tokens across all sectors" },
  ai: { name: "AI & Machine Learning", emoji: "🤖", description: "Artificial intelligence tokens revolutionizing crypto" },
  gaming: { name: "Gaming & Metaverse", emoji: "🎮", description: "Play-to-earn and metaverse gaming tokens" },
  defi: { name: "DeFi", emoji: "🏦", description: "Decentralized finance protocols and yield generators" },
  layer1: { name: "Layer 1 Blockchains", emoji: "⚡", description: "Next-generation blockchain infrastructure" },
  layer2: { name: "Layer 2 Scaling", emoji: "🔗", description: "Ethereum scaling solutions and rollups" },
  nft: { name: "NFT & Collectibles", emoji: "🖼️", description: "NFT platforms and digital collectibles" },
  payments: { name: "Payments & Currency", emoji: "💰", description: "Payment infrastructure and digital currencies" },
  meme: { name: "Meme Coins", emoji: "🐶", description: "Community-driven meme tokens with utility" },
  privacy: { name: "Privacy Coins", emoji: "🔒", description: "Privacy-focused blockchain protocols" },
  storage: { name: "Storage & Data", emoji: "💾", description: "Decentralized storage and data solutions" },
  rwa: { name: "Real World Assets", emoji: "🏛️", description: "Tokenization of real-world assets" },
  exchange: { name: "Exchange Tokens", emoji: "🏪", description: "Native tokens of cryptocurrency exchanges" },
  stablecoin: { name: "Stablecoins", emoji: "💵", description: "Price-stable cryptocurrencies pegged to fiat" },
  infrastructure: { name: "Infrastructure", emoji: "🏗️", description: "Core blockchain infrastructure and tools" },
  dao: { name: "DAO & Governance", emoji: "🗳️", description: "Decentralized autonomous organizations" },
  oracle: { name: "Oracles", emoji: "🔮", description: "Blockchain oracles providing real-world data" },
  interoperability: { name: "Interoperability", emoji: "🌉", description: "Cross-chain communication protocols" },
  derivatives: { name: "Derivatives", emoji: "📊", description: "Synthetic assets and derivatives trading" },
  lending: { name: "Lending & Borrowing", emoji: "🏦", description: "Decentralized lending protocols" },
  yield: { name: "Yield Farming", emoji: "🌾", description: "Yield optimization platforms" }
};